import { memo, useCallback, useMemo } from 'react';

import { OnOffShareToggleRow } from '~/components/ShareModal/components/OnOffShareToggleRow';
import { UpsellFlashIconButton } from '~/components/ShareModal/components/UpsellFlashIconButton';
import { useShowcaseModal } from '~/components/ShowcaseModal/ShowcaseModalContext';
import { SHARE_MODAL_UPSELL_MESSAGE } from '~/constants/upsells';
import { useShareSettings } from '~/hooks/useShareSettings';

/** Create-mode smart leaf: hide-Air-logo toggle. Writes draft state, no per-change analytics. */
export const CreateShowcaseSettingsHideAirLogoRow = memo(() => {
  const { shortUrlProps, isSaving, updateHideAirLogo } = useShowcaseModal();
  const { removeAirLogoEnabled } = useShareSettings();

  const hideAirLogo = useMemo(
    () => shortUrlProps.presentationSettings?.hideAirLogo === true,
    [shortUrlProps.presentationSettings?.hideAirLogo],
  );

  const labelAccessory = useMemo(
    () =>
      !removeAirLogoEnabled ? <UpsellFlashIconButton>{SHARE_MODAL_UPSELL_MESSAGE}</UpsellFlashIconButton> : undefined,
    [removeAirLogoEnabled],
  );

  const handleToggleHideAirLogo = useCallback(
    (checked: boolean) => {
      updateHideAirLogo(checked);
    },
    [updateHideAirLogo],
  );

  return (
    <OnOffShareToggleRow
      label="Hide Air logo"
      labelAccessory={labelAccessory}
      checked={hideAirLogo}
      isLoading={isSaving}
      disabled={!removeAirLogoEnabled}
      onToggle={handleToggleHideAirLogo}
      data-testid="HIDE_AIR_LOGO_TOGGLE"
    />
  );
});

CreateShowcaseSettingsHideAirLogoRow.displayName = 'CreateShowcaseSettingsHideAirLogoRow';
